import { Injectable } from '@angular/core';
import { G_TagsViewModel } from 'src/app/viewmodels/g-settings/G_TagsViewModel';
import { EndpointConfig } from '../../common/EndpointConfig';
import { HttpClient } from '@angular/common/http';
import { IHttpService } from '../../common/IHttpService';

@Injectable({
  providedIn: 'root'
})
export class TagsService implements IHttpService<G_TagsViewModel>  {
  private _ep: EndpointConfig;
  constructor(private _client: HttpClient) {
    this._ep = new EndpointConfig('GSettings');
  }

  GetList() {
    return this._client.get(this._ep.getEndpointMethod('GetG_TagsList'));
  }

  checkDublication(code) {
    return this._client.post(this._ep.getEndpointMethod('CheckTagDublication'), { Code: code });
  }

  GetById(id: any) {
    return this._client.post(this._ep.getEndpointMethod('GetG_TagsById'), { Id: id });
  }
  Post(obj: G_TagsViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_Tags'), obj);
  }

  Put(obj: G_TagsViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_Tags'), obj);
  }

  Delete(obj: G_TagsViewModel) {
    return this._client.post(this._ep.getEndpointMethod('DeleteG_Tags'), obj);
  }
}
